import { api } from 'api'

type ISOString = string

type GetTipHistoryRequest = {
  companyId: number
  filters: { workerId?: number; shiftId?: number }
}

type GetTipHistoryResponse = {
  tipTakeRate?: number
  totalPaymentAmount: number
  totalChargeAmount: number
  workHistory: {
    totalPaymentAmount: number
    totalChargeAmount: number
    work: {
      workId: number
      startedAt: ISOString
      completedAt: ISOString
      worker: {
        workerId: number
        name: string
        profilePicUrl?: string
      }
      shift: {
        shiftId: number
        startsAt: ISOString
        endsAt: ISOString
        location?: {
          locationId: number
          name: string
          timezone: string
        }
        position: {
          positionId: number
          name: string
        }
      }
    }
    chargeHistory: {
      chargeItemId: number
      amount: number
      createdAt: ISOString
    }[]
    paymentHistory: {
      userPaymentId: number
      amount: number
      createdAt: ISOString
    }[]
  }[]
}

export async function getTipHistory({
  companyId,
  filters,
}: GetTipHistoryRequest) {
  const response = await api.get<GetTipHistoryResponse>(
    `/company/${companyId}/tip/work`,
    {
      params: {
        workerIds: filters.workerId ? [filters.workerId] : undefined,
        shiftIds: filters.shiftId ? [filters.shiftId] : undefined,
      },
    }
  )

  return response.data
}
